import React from "react";
import { Phone } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { T } from "../lib/translations";
import { waLink, WhatsAppIcon } from "./WhatsAppFloat";

/**
 * Persistent mobile action bar — always visible at the bottom of the viewport
 * on phones. Distressed users get one-thumb access to a call or WhatsApp chat
 * instead of hunting for the form.
 * Click tracking is handled globally by the delegated listener in analytics.js.
 */
export default function MobileCallBar() {
  const { lang } = useLang();
  return (
    <>
      {/* Flow spacer so the fixed bar never hides page footer content */}
      <div className="h-[76px] lg:hidden" aria-hidden="true" />
      <div
        className="fixed bottom-0 inset-x-0 z-30 lg:hidden bg-white/95 backdrop-blur border-t border-[#D8CDBA] px-3 py-2.5 flex gap-2"
        data-testid="mobile-call-bar"
      >
        <a
          href={`tel:${T.phone.number}`}
          className="flex-[1.4] inline-flex items-center justify-center gap-2 py-3 rounded-xl bg-[#A83F32] text-white text-sm font-medium"
          data-testid="mobile-bar-call"
        >
          <Phone size={16} strokeWidth={2.2} />
          {lang === "hi" ? "अभी कॉल करें" : "Call Now"}: {T.phone.display}
        </a>
        <a
          href={waLink(lang)}
          target="_blank"
          rel="noreferrer"
          className="flex-1 inline-flex items-center justify-center gap-2 py-3 rounded-xl bg-[#25D366] text-white text-sm font-medium"
          data-testid="mobile-bar-whatsapp"
        >
          <WhatsAppIcon size={18} />
          WhatsApp
        </a>
      </div>
    </>
  );
}
